<template>
  <upload-view :images="images" :max="1" @change="args => $emit('update:image', args.length == 1 ? args[0] : '')"
               show-upload-button :show-upload-list="{showRemoveIcon: false, showDownloadIcon: false}" v-bind="$attrs"/>
</template>

<script setup lang="ts">

import UploadView from "@/views/share/UploadView.vue";
import {computed} from "vue";

const props = defineProps<{ image: string | null, title?: string }>()
defineEmits(['update:image', 'change'])
const images = computed(() => props.image ? [props.image] : [])
</script>

<style scoped lang="sass">

</style>